import AuthService from "../Components/auth/AuthService";
const Auth = new AuthService()

export const fetchProducts = async () => {
    const res = await Auth.fetch(`/product/products`, );
    return res;
};

export const fetchLocations = async () => {
    const res = await Auth.fetch(`/location/locations`, );
    return res;
};
export const fetchLocationStockByProduct = async (payload) => {
    const res = await Auth.fetch(`/product-location/location-stock-by-product-batches?id=${payload}`, );
    return res;
};

export const fetchLocationBatches = async (payload) => {
    const res = await Auth.fetch(`/stock/location-batches?location_id=${payload?.location}&product_netsuite_id=${payload?.product}`, );
    return res;
};

